import { NgModule } from '@angular/core';
import {
  DefaultDataServiceConfig,
  EntityCollectionReducerMethodsFactory,
  EntityDataModule,
  EntityDataService,
  HttpUrlGenerator,
  PersistenceResultHandler,
} from '@ngrx/data';
import { EffectsModule } from '@ngrx/effects';
import { PlClientDataService } from '@common/entities/pl-client-data.service';
import { PlEventDataService } from '@common/entities/pl-event-data.service';
import { environment } from '@environments/environment';
import {
  PlEntityCollectionReducerMethodsFactory,
  PlPersistenceResultHandler,
} from 'pl-core-services';
import { PluralHttpUrlGenerator } from '@common/entities/url-generator';
import { PlEventService } from '@common/entities/pl-event.service';

import { PlApiModule } from '@common/pl-api.module';
import { entityConfig } from './entity-metadata';
import { PlUserService } from './pl-user.service';
import { PlClientService } from './pl-client.service';
import { PlClientEffects } from './clients/effects';

const defaultDataServiceConfig: DefaultDataServiceConfig = {
  root: `${environment.apps.kanga}/api/v1`,
};

@NgModule({
  imports: [
    PlApiModule,
    EntityDataModule.forRoot(entityConfig),
    EffectsModule.forFeature([PlClientEffects]),
  ],
  providers: [
    { provide: DefaultDataServiceConfig, useValue: defaultDataServiceConfig },
    { provide: HttpUrlGenerator, useClass: PluralHttpUrlGenerator },
    { provide: PersistenceResultHandler, useClass: PlPersistenceResultHandler },
    {
      provide: EntityCollectionReducerMethodsFactory,
      useClass: PlEntityCollectionReducerMethodsFactory,
    },
    PlClientDataService,
    PlEventDataService,
    PlClientService,
    PlEventService,
    PlUserService,
  ],
})
export class PlEntityStoreModule {
  constructor(
    entityDataService: EntityDataService,
    clientDataService: PlClientDataService,
    eventDataService: PlEventDataService
  ) {
    entityDataService.registerService('Client', clientDataService);
    entityDataService.registerService('Event', eventDataService);
  }
}
